export { default as ModalDialog } from './ModalDialog'
export { ModalDialogVariant } from './types'
export type { ModalDialogProps } from './types'
